module.exports = __webpack_public_path__ + "static/media/HRD.2ef3a9f2.png";